/**
 * VMS errors often use `{ code, message }`.
 * Programs authorization often uses `{ error }` and/or `{ message }`.
 *
 * For HTTP 401/403 we append a hint, since the most common cause is that the
 * logged-in user's role-resource lacks the required permission in the
 * `grantAccess` middleware (e.g. create on role-resource-permission).
 */
export function extractRbacAxiosError(error: unknown, fallback: string): string {
  const err = error as {
    response?: { data?: unknown; status?: number };
    message?: string;
  };
  const data = err.response?.data;
  const status = err.response?.status;

  let message = fallback;

  if (data && typeof data === "object") {
    const o = data as Record<string, unknown>;
    if (typeof o.message === "string" && o.message.trim()) message = o.message;
    else if (typeof o.error === "string" && o.error.trim()) message = o.error;
  } else if (typeof err.message === "string" && err.message.trim()) {
    message = err.message;
  }

  if (status === 401 || status === 403) {
    const lower = message.toLowerCase();
    if (lower.includes("permission") || lower.includes("forbidden") || lower.includes("unauthor")) {
      return `${message} — your logged-in account must have create/update permission on this RBAC resource. Check "My access" on the RBAC page.`;
    }
  }

  return message;
}
